export const AGENTPLANE_ORIGIN = 'https://agentplane.ejaaz.online';
